import { EquipmentMasterThemeSizeConfig } from './types';

const medium: EquipmentMasterThemeSizeConfig = {
  equipmentMaster: {},
};

export default medium;
